import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Box, Divider, Skeleton, Typography } from "@mui/material";

import { ServiceContract } from "../../../../../types/service.type";

export const ContractServiceDetailsCard = ({ contractDetails }: { contractDetails: ServiceContract }) => {
  const { t } = useTranslation("goService", { keyPrefix: "serviceRequestPage" });

  const {
    serviceRequest: {
      service: { name, serviceNumber, description },
    },
  } = contractDetails;

  const serviceDetailsList = [
    { label: t("serviceName"), value: name },
    { label: t("serviceCode"), value: serviceNumber },
    { label: t("description"), value: description },
  ];

  return (
    <Box sx={styles.container}>
      {serviceDetailsList.map(({ label, value }, idx) => (
        <Fragment key={idx}>
          <Box sx={styles.serviceDetailContainer}>
            <Typography component="label" sx={styles.serviceDetailLabel}>
              {label}
            </Typography>
            <Typography component="span" sx={styles.serviceDetailValue}>
              {value}
            </Typography>
          </Box>
          {idx !== serviceDetailsList.length - 1 && <Divider />}
        </Fragment>
      ))}
    </Box>
  );
};

export const ContractServiceDetailsCardLoader = () => {
  return (
    <Box sx={styles.container}>
      {Array.from({ length: 3 }).map((_, idx) => (
        <Fragment key={idx}>
          <Box sx={styles.serviceDetailContainer}>
            <Skeleton variant="text" width="50%" height="18px" />
            <Skeleton variant="text" width="30%" height="24px" />
          </Box>
          {idx !== 2 && <Divider />}
        </Fragment>
      ))}
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "var(--Gray---25, #F7F8F8)",
    padding: "16px",
  },
  serviceDetailContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  serviceDetailLabel: {
    fontFamily: "Montserrat",
    color: "var(--Dark---800, #414141)",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "18px",
  },
  serviceDetailValue: {
    fontFamily: "Montserrat",
    color: "var(--Dark---900, #1A1C21)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
};
